export default __webpack_public_path__ + "static/media/ci_202401.8ac95714.png";